<template>
  <div class="alert_width">
    <div style="padding: 0 10px">{{ $t('etc.notice.title') }}</div>
    <b-dropdown-divider></b-dropdown-divider>
    <div class="alert-body">
      <div v-if="loading && alert_list.length === 0" style="height: 50px">
        <div style="transform: translate(-50%, 0); position: absolute; left: 50%; height: 50px">
          <div id="loading"></div>
        </div>
      </div>
      <div v-else-if="alert_list.length === 0" class="text-muted" style="padding: 0 10px">
        {{ $t('etc.notice.err') }}
      </div>

      <div v-else v-for="(alert, index) in alert_list" :key="index">
        <div style="padding: 0 10px">
          <div class="d-flex align-items-center justify-content-between">
            <div class="text-black bold font-s16 mt-1">
              {{ alert.title }}
            </div>

            <button @click="deleteNoti(alert.id)" style="padding: 0 !important">
              <img class="close" :src="`${$s3}/img/common/mypage/delete.svg?${$ver}`" />
            </button>
          </div>

          <div class="d-flex align-items-end justify-content-between" style="gap: 1rem">
            <div class="font-s14 mt-1" style="color: #666666">
              <div>{{ alert.content.split('|')[0] }}</div>
              <div>{{ alert.content.split('|')[1] }}</div>
            </div>

            <div class="text-muted font-s12 mt-1">
              {{ $tfDateShort($tl(alert.createdAt, lang)) }}
            </div>
          </div>
        </div>
        <b-dropdown-divider v-if="index < alert_list.length - 1"></b-dropdown-divider>
      </div>
      <button @click="goToAlert" class="go-to-alert">{{ $t('etc.notice.seeall') }}</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['goToAlert'],
  created() {
    this.alertList();
  },
  computed: {
    ...mapState({
      newNoti: (state) => state.newNoti,
      lang: (state) => state.lang,
      isLogin: (state) => state.isLogin,
    }),
  },
  data() {
    return {
      alert_list: [],
      loading: false,
    };
  },
  methods: {
    setAlertList(data) {
      setTimeout(() => {
        this.loading = false;
        this.alert_list = [...data];
      }, 500);
    },
    alertList() {
      this.loading = true;
      this.$axios
        .get(`${process.env.VUE_APP_TEST_SERVER}/user/noti`)
        .then((response) => {
          this.$store.commit('readNoti', {});
          const { data } = { ...response.data };
          this.setAlertList(data);
        })
        .catch(() => this.setAlertList([]));
    },
    deleteNoti(id) {
      this.$axios
        .post(
          `${process.env.VUE_APP_TEST_SERVER}/user/noti/delete`,
          {
            notiId: id,
          },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
          }
        )
        .finally(() => {
          this.alert_list = [];
          this.alertList();
        });
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu.header-menu {
  padding-bottom: 0;
}
.icn-route-btn.alert-btn {
  padding: 6px;
  border: 0 !important;
}
</style>

<style lang="scss" scoped>
.alert_width {
  width: 369px;
  overflow-y: hidden;

  @media screen and (max-width: 992px) {
    width: calc(100vw - 15px);
  }

  .alert-body {
    position: relative;
    max-height: 360px;
    overflow-y: auto;

    button {
      position: sticky;
      bottom: 0;
    }
  }
}
button.go-to-alert {
  margin-top: 0.5rem;
  width: 100%;
  background: #fafafa;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  display: grid;
  place-items: center;
  border: 1px solid#ededed;
  height: 42px;
}
</style>
